import { useMutation } from "react-query";
import { postLandingsOrder } from "../api/postLandingsOrder";

export const usePostLandingsOrder = () => useMutation(postLandingsOrder);
